import type { OnyxOption } from '@onyx/angular';

export const YES_NO_OPTIONS: OnyxOption<boolean>[] = [
  { name: 'labels.yes', value: true },
  { name: 'labels.no', value: false },
] as const;
